import React from 'react'

const Loaders = () => {
  return (

<div className="border  shadow rounded-md p-4 h-[250px] w-full mx-auto">
  <div className="animate-pulse  w-full h-full    space-x-4">
    <div className="rounded-full ml-4  bg-slate-200 mt-2 h-10 w-10">
    <div className="grid grid-cols-12 gap-4 border-b-2 ">
          <div className="h-2 bg-slate-200 mb-2 rounded col-span-3 col-start-4"></div>
          <div className="  col-span-6   h-2 bg-slate-200 rounded-full  "></div>
        </div>
        <div className="grid grid-cols-12 gap-4 mt-2 ">
          <div className="h-2 bg-slate-200 mb-2 rounded col-span-10 col-start-4"></div>
        </div>
    </div>
    <div className="flex-1 space-y-6 py-4">
      <div className="space-y-3">
        <div className="grid grid-cols-12 gap-4 border-b-2 ">
          <div className="h-2 bg-slate-200 mb-2 rounded col-span-2"></div>
          <div className=" col-span-2  "></div>
          <div className="h-2 bg-slate-200 rounded col-span-2"></div>
          <div className=" col-span-5   "></div>
          <div className="h-2 bg-slate-200 rounded col-span-1"></div>
        </div>
        <div className="grid grid-cols-12 gap-4 border-b-2 ">
          <div className="h-2 bg-slate-200 mb-2 rounded col-span-2"></div>
          <div className=" col-span-2  "></div>
          <div className="h-2 bg-slate-200 rounded col-span-2"></div>
          <div className=" col-span-5   "></div>
          <div className="h-2 bg-slate-200 rounded col-span-1"></div>
        </div>  <div className="grid grid-cols-12 gap-4 border-b-2 ">
          <div className="h-2 bg-slate-200 mb-2 rounded col-span-2"></div>
          <div className=" col-span-2  "></div>
          <div className="h-2 bg-slate-200 rounded col-span-2"></div>
          <div className=" col-span-5   "></div>
          <div className="h-2 bg-slate-200 rounded col-span-1"></div>
        </div>
        <div className="grid grid-cols-12 gap-4 border-b-2 ">
          <div className="h-2 bg-slate-200 mb-2 rounded col-span-2"></div>
          <div className=" col-span-2  "></div>
          <div className="h-2 bg-slate-200 rounded col-span-2"></div>
          <div className=" col-span-5   "></div>
          <div className="h-2 bg-slate-200 rounded col-span-1"></div>
        </div>


          <div className="grid grid-cols-12 gap-4 m-8 ">
          <div className="h-2 bg-slate-200  rounded col-span-1  col-start-3"></div>
          <div className="h-2 bg-slate-200  rounded col-span-5  col-start-8"></div>
          
        </div>
        
      </div>
    </div>
  </div>
</div>    )
}

export default Loaders